var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CardPage',{attrs:{"section":_vm.section,"page":_vm.page}},_vm._l((_vm.myGoalsCategories),function(category,index){return _c('p',{key:index},[_vm._v("\n        "+_vm._s(_vm.blurbs[category])+"\n    ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }